module.exports = __webpack_public_path__ + "img/horizontalprincipalbeca.a1f6d53e.png";